
//export const BACK_URL = 'http://localhost:8000/storage/'

export const BACK_URL = 'https://visennia.com/api/storage/app/public/'


//export const BACK_URL = 'https://visennia.com/api/public/storage/'
